export const CONTROL_TYPE = {
  CHECKBOX: "Checkbox",
  RADIO: "Radio",
  TEXT_BOX: "Textbox",
  DATE: "Date",
};

export const DATA_TYPE = {
  TEXT: "Text",
  FLOAT: "Float",
  INTEGER: "Integer",
  DATE: "Date",
};

export const USER_TYPE = {
  ADMIN: "Admin",
  USER: "User",
  GUEST: "Guest",
  NONE: "None",
};

export const POST_STATUS = {
  confirmed: "확인완료",
  rejected: "반려",
  done: "신청완료",
  reviewing: "확인중",
  pending: "접수미정",
  waiting: "대기",
  replied: "답변있음",
};

export const POST_STATUS_IDEA = {
  confirmed: "확인완료",
  rejected: "반려",
  done: "심사완료",
  reviewing: "심사중",
  pending: "접수미정",
  waiting: "대기",
  replied: "답변있음",
};

export const BOARD_CODE = {
  NOTICE: "notice",
  ANNUAL_REPORT: "annual-report",
  FAQ: "faq",
  BABY_CHEER: "baby-cheer",
  CARE_CHEER: "care-cheer",
  BABY_MEMORIAL: "baby-memorial",
  GENERAL_RESOURCE: "general-resource",
  QUESTION: "question",
  RESEARCH_BOARD: "research-board",
  RESEARCH_RESOURCE: "research-resource",
  RESEARCH_PROPOSAL: "research-proposal",
  RESEARCH_QNA: "research-qna",
  CONTACT: "contact",
};
